import devname from "@/ids/devname";
import attached from "@/ids/attached";
import internet from "@/ids/internet";
import wan from "@/ids/wan";
import accessControl from "@/ids/accessControl";
import blockServices from "@/ids/blockServices";
import ddns from "@/ids/ddns";
import staticRoutes from "@/ids/staticRoutes";
import vlan from "@/ids/vlan";
import logs from "@/ids/logs";
import ntpSettings from "@/ids/ntpSettings";
import setPassword from "@/ids/setPassword";
import basicHome from "@/ids/basicHome";
import lan from "@/ids/lan";
import rae from "@/ids/rae";
import pfPt from "@/ids/pfPt";
import vpnService from "@/ids/vpnService";
import ipv6 from "@/ids/ipv6";
import common from "@/ids/common";
import Debug from "@/ids/Debug";
export const ids = {
  devname,
  attached,
  internet,
  wan,
  accessControl,
  blockServices,
  ddns,
  staticRoutes,
  vlan,
  logs,
  ntpSettings,
  setPassword,
  basicHome,
  lan,
  rae,
  pfPt,
  vpnService,
  ipv6,
  common,
  Debug,
};

export default ids;
